/**
 * @file permission-getters.js
 */

export default {
    hasSystemPermission(state) {
        return state.isLogin
        && state.permission.SYSTEM;
    },
    hasQaAdminPermission(state) {
        return state.isLogin
            && state.permission.QA_ADMIN;
    },
    hasSupportPermission(state) {
        return state.isLogin
            && state.permission.SUPPORT;
    },
    hasDevelopPermission(state) {
        return state.isLogin
        && state.permission.DEVELOP;
    },
    hasOfficialPermission(state) {
        return state.isLogin
            && (state.permission.SYSTEM
            || state.permission.QA_ADMIN
            || state.permission.SUPPORT
            || state.permission.DEVELOP);
    }
};
